// extracted by mini-css-extract-plugin
export default {"storychestColor":"#dc3151","selectedDay":"day_picker_selectedDay__L+ZzC"};